import * as React from 'react'
import Spinner from '../../components/Spinner'
import { Link } from 'react-router-dom'

class ManageEventListScreen extends React.Component {
  componentDidMount() {
    this.props.getEvents()
  }

  render() {
    const { events } = this.props.events
    if( events===null ) return <Spinner />
    return (
      <div>
        <Link
            className="btn btn-primary btn-sm btn-block mb-3"
            to="manage-event-detail"
          >Dodaj wydarzenie
        </Link>

        <div className="list-group">
          {events.map( (article, key) => (
          <Link 
            key={key}
            className="list-group-item"
            to={{
              pathname: 'manage-event-detail',
              article
            }}
          >
            {article.title}
          </Link>
          ))}
        </div>
      </div>
    )
  }
}

export default ManageEventListScreen


// WEBPACK FOOTER //
// ./src/screens/ManageEvents/ManageEventListScreen.js